<div class="container" fxLayoutAlign="flex-start stretch">
  <div class="sidenav" fxLayout="column">
    <img
      class="pointer"
      src="assets/images/sign/gorenjska_banka_logo.svg"
      alt="leonus logo"
      routerLink="/home"
    />
    <div class="mt-75">
      <ng-container *ngFor="let nav of navigationItems">
        <div
          class="sidenav__item mb-5 pointer"
          fxLayoutAlign="flex-start center"
          *ngIf="
            (!nav.permission || hasAppPermission(nav.permission)) &&
            checkIfLinkVisible(nav)
          "
          [routerLink]="nav.route"
          [routerLinkActive]="['active']"
          [routerLinkActiveOptions]="{ exact: nav.route === '/' }"
          #rla="routerLinkActive"
        >
          <div class="sidenav__icon" fxLayoutAlign="flex-start center">
            <img
              src="assets/images/sidenav/{{
                rla.isActive && !exchangeModalOpened ? nav.iconActive : nav.icon
              }}.svg"
              alt="icon"
            />
            <!-- <span
              *ngIf="
                nav.name === 'more_options_crm' &&
                (crmData$ | async)?.offers?.countMessages > 0
              "
              class="crm-count"
            >
              {{ (crmData$ | async)?.offers?.countMessages }}
            </span> -->
          </div>
          <p [ngClass]="{ inactive: exchangeModalOpened }">
            {{ nav.name | translate }}
          </p>
        </div>
      </ng-container>
      <ng-container *ngIf="hasAppPermission('VIEW_ACCOUNTS')">
        <div
          class="sidenav__item mb-10 pointer"
          fxLayoutAlign="flex-start center"
          [routerLinkActive]="['active']"
          [ngClass]="{ active: exchangeModalOpened }"
          (click)="openExchangeModal()"
        >
          <img
            *ngIf="exchangeModalOpened"
            src="assets/images/sidenav/exchange_active.svg"
            alt=""
            class="mr-16"
          />
          <img
            *ngIf="!exchangeModalOpened"
            src="assets/images/sidenav/exchange.svg"
            alt=""
            class="mr-16"
          />
          <p>{{ 'more_options_exchange' | translate }}</p>
        </div>
      </ng-container>
    </div>

    <div
      fxLayoutAlign="flex-start center"
      class="sidenav__profile pointer"
      [routerLink]="['/profile']"
      [routerLinkActive]="['active']"
    >
      <div @scaleIn class="circle-50 mr-10">
        <ng-container *ngIf="profileImage$ | async as profileImg">
          <img
            *ngIf="profileImg.data; else initials"
            class="profile"
            [src]="profileImg?.data"
            alt="profile"
          />
        </ng-container>
        <ng-template #initials>
          <span class="text-blue font-bold font-18">{{ profileInitials }}</span>
        </ng-template>
      </div>
      <p class="client">{{ client | titlecase }}</p>
    </div>
  </div>
  <main class="main" fxFlex="100" [ngClass]="{ 'main-crm': crmBgColor() }">
    <router-outlet></router-outlet>
  </main>
  <main
    class="sidebar"
    [ngClass]="{ 'sidebar--open': sidebar.isActivated }"
    fxFlex="noshrink"
  >
    <div class="sidebar__content">
      <router-outlet name="sidebar" #sidebar="outlet"></router-outlet>
    </div>
  </main>
</div>
<ng-container *ngIf="hasAppPermission('VIEW_ACCOUNTS')">
  <lns-exchange-modal
    *ngIf="exchangeModalOpened"
    [modalContent]="exchangeContent"
    (closeModal)="openExchangeModal()"
  ></lns-exchange-modal>
</ng-container>
